import React, { useState, useEffect } from 'react';
import { isAuthenticated } from '../../store/action/auth';
import { getAdminOrders, confirmAdminBatchOrder } from '../../store/action/order';
import AdminOrderTable from '../../components/tables/AdminOrderTable';
import AdminInfoForm from '../../components/forms/AdminInfoForm';
import { CSVLink } from "react-csv";
import { Nav, Modal, Button } from 'react-bootstrap';
import { RefreshButton } from '../../components/buttons';
import { getAdminInfo, updateAdminInfo } from '../../store/action/admin';
import {API} from "../../config";
import axios from "axios";
import ReactLoading from "react-loading";
import moment from 'moment';

const AdminOrder = () => {
  const { token } = isAuthenticated();
  const [error, setError ] = useState(false);
  const [success, setSuccess ] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading ] = useState(true);
  const [deliveredOrders, setDeliveredOrders ] = useState(true);
  const [refreshing, setRefreshing] = useState(false)
  const [tab, setTab] = useState(2)
  const [orders, setOrders] = useState({
    all: [],
    tab:1,
    normalOrders:[],
    formOrders:[],
    pendingOrders:[],
    laterOrders: [],
    nowOrders: [],
    scheduledOrders:[],
    onHoldOrders:[],
    processingOrders: [],
    pickingUpOrders: [],
    picked:[],
    otwOrders: [],
    deliveredOrders: [],
    downloadable: [],
    rejectedOrders: [],
    returnInTransitOrders:[],
    courierNotFoundOrders: [],
    days1NotPickedOrders:[],
    days2NotPickedOrders:[],
    days3NotPickedOrders:[],
    days7NotPickedOrders:[],
    days14NotPickedOrders:[],
    days30NotPickedOrders:[],
    days30AboveNotPickedOrders:[],
  });
  const [values, setValues] = useState({
    information:'',
    details:'',
    status:'active'
  });

  useEffect(() => {
    _fetchData()
  }, []);

  const _fetchData = async () => {
    const resOr = await getAdminOrders(token);
    const resAd = await getAdminInfo(token);
  
 
    if(resOr.status && resAd.success){
   

      let orders = resOr.orders.reduce((result, i, idx) => {
        // days till picked
        let timeToPickup = 0;
        if (i.courier.history && i.courier.history.length > 0) {
          const arr = i.courier.history.filter(i => i.status === 'confirmed' || i.status === 'allocated')[0];
          if (arr && arr.eventDate) {
            timeToPickup = moment().diff(moment(arr.eventDate), 'days')       
          } 
        }

        if (i._id) {

          if (!i.shipper) {
            console.log("CEK >> " + i._id)
            return result
          }
          result.push({
            orderId: i._id,
            userId: i.userId,
            shipperName: i.shipper ? i.shipper.name : "",
            shipperPhone: i.shipper ? i.shipper.phone : "",
            shipperEmail: i.shipper ? i.shipper.email : "",
            shipperOrganization: i.shipper ? i.shipper.organization : "",
            receiverName: i.receiver ? i.receiver.name : "",
            receiverPhone: i.receiver ? i.receiver.phone : "",
            receiverEmail: i.receiver ? i.receiver.email : "",
            receiverLocation: i.receiver ? i.receiver.location : "",
            receiverPostalCode: i.receiver ? i.receiver.postalCode : "",
            receiverNote: i.receiver ? i.receiver.note : "",
            receiverCODAmount: i.receiver ? i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.amount : null : null,
            receiverCODNote: i.receiver ? i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.note : null : null,
            receiverCODStatus: i.receiver ? i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.status : null : null,
            receiverCODType: i.receiver ? i.receiver.cashOnDelivery ? i.receiver.cashOnDelivery.type : null : null,
            originName: i.origin ? i.origin.name : "",
            originLocation: i.origin ? i.origin.location : "",
            originNote: i.origin ? i.origin.note : "",
            originPostalCode: i.origin ? i.origin.postalCode : "",
            originPhone: i.origin ? i.origin.phone : "",
            orderType: i.type,
            items: i.items,
            isInstantWaybill: i.isInstantWaybill,
            paymentSlip: i.images.paymentSlip,
            price: i.price,
            courierTrackingId: i.courier ? i.courier.trackingId : "",
            courierCompany: i.courier ? i.courier.company : "",
            courierName: i.courier ? i.courier.name : "",
            courierPhone: i.courier ? i.courier.phone : "",
            courierType: i.courier ? i.courier.type : "",
            courierLink: i.courier ? i.courier.link : "",
            courierHistory: i.courier ? i.courier.history : "",
            courierWaybillId: i.courier ? i.courier.waybillId : "",
            courierInsuranceAmount: i.courier ? i.courier.insurance ? i.courier.insurance.amount : null : null,
            courierInsuranceFee: i.courier ? i.courier.insurance ? i.courier.insurance.fee : null : null,
            courierStatus: i.courier ? i.courier.history ? i.courier.history.length > 0 ? i.courier.history[i.courier.history.length-1].status : "" : "" : "",
            createdAt: i.createdAt,
            deliveryType: i.delivery.type,
            deliveryDate: i.delivery.date,
            deliveryTime: i.delivery.time,
            deliveryNote: i.delivery.note,
            extra: i.extra,
            weight: i.weight,
            volume: i.volume,
            paymentType: i.paymentType,
            paymentMethod: i.paymentMethod,
            receiptLink: i.receiptLink,
            timeToPickup:timeToPickup,
            note:i.note,
            status: i.status,
            selected:false,
            updatedAt: i.updatedAt
          });
        }
        
        return result
      }, []);

      orders = orders.sort((a, b) => {
          var dateA = new Date(a.deliveryDate);
          var dateB = new Date(b.deliveryDate);
          return dateB - dateA;
      });

      let downloadable = orders.reduce((res, i) => {
        res.push({
          ...i,
          items: JSON.stringify(i.items)
        });
        return res
      },[]);

      let formOrders = orders.filter(i => i.orderType === 'form');
      let normalOrders = orders.filter(i => i.orderType !== 'form');
      let scheduledOrders = normalOrders.filter(i => i.status === 'scheduled' );
      let pendingOrders = normalOrders.filter(i => i.status === 'pending' );
      let laterOrders = normalOrders.filter(i => i.status === 'placed' );
      let onHoldOrders = normalOrders.filter(i => i.status === 'onHold' );
      let nowOrders = normalOrders.filter(i => i.status === 'confirmed' );
      let processingOrders = normalOrders.filter(i => i.status === 'allocated' );
      let pickingUpOrders = normalOrders.filter(i => i.status === 'pickingUp' );
      let picked = normalOrders.filter(i => i.status === 'picked' );
      let otwOrders = normalOrders.filter(i => i.status === 'droppingOff' );
      let returnInTransitOrders = normalOrders.filter(i => i.status === 'returnInTransit' );
      let deliveredOrders = normalOrders.filter(i => i.status === 'delivered' );
      let rejectedOrders = normalOrders.filter(i => i.status === 'rejected');
      let courierNotFoundOrders = normalOrders.filter(i => i.status === 'courierNotFound');
      let days1NotPickedOrders = normalOrders.filter(i => i.timeToPickup <= 1)
      let days2NotPickedOrders = normalOrders.filter(i => i.timeToPickup > 1 && i.timeToPickup <= 2)
      let days3NotPickedOrders = normalOrders.filter(i => i.timeToPickup > 2 && i.timeToPickup <= 3)
      let days7NotPickedOrders = normalOrders.filter(i => i.timeToPickup > 3 && i.timeToPickup <= 7)
      let days14NotPickedOrders = normalOrders.filter(i => i.timeToPickup > 7 && i.timeToPickup <= 14)
      let days30NotPickedOrders = normalOrders.filter(i => i.timeToPickup > 14 && i.timeToPickup <= 30)
      let days30AboveNotPickedOrders = normalOrders.filter(i => i.timeToPickup > 30)

      setOrders({
        ...orders,
        all: orders,
        normalOrders,
        formOrders,
        onHoldOrders,
        downloadable,
        scheduledOrders,
        pendingOrders,
        laterOrders,
        nowOrders,
        processingOrders,
        pickingUpOrders,
        picked,
        otwOrders,
        returnInTransitOrders,
        deliveredOrders,
        rejectedOrders,
        courierNotFoundOrders,
        days1NotPickedOrders,
        days2NotPickedOrders,
        days3NotPickedOrders,
        days7NotPickedOrders,
        days14NotPickedOrders,
        days30NotPickedOrders,
        days30AboveNotPickedOrders
      });
      setValues({
        ...values,
        information:resAd.admin.information,
        details:resAd.admin.details,
        status:resAd.admin.status
      });
      setLoading(false)
    } else {
      return alert("Gagal mengambil data. Coba refresh atau ulangi beberapa saat lagi")
    }
  };


  const adminTab = () => {
    let tabOrders = setOrdersByTab(tab);
    return (
      <AdminOrderTable
        data={tabOrders}
        tab={orders.tab}
        loading={loading}
        onRefresh={onRefresh}
        onClickCheckBox={onClickCheckBox}
      />
    )
  };


  const setOrdersByTab = (tab) => {
    let value;
    if (tab === 0) {
      value = orders.pendingOrders;
    } else if (tab === 1) {
      value = orders.laterOrders;
    } else if (tab === 2) {
      value = orders.nowOrders;
    } else if (tab === 3) {
      value = orders.processingOrders;
    } else if (tab === 4) {
      value = orders.pickingUpOrders;
    } else if (tab === 5) {
      value = orders.picked;
    } else if (tab === 6) {
      value = orders.otwOrders;
    } else if (tab === 7) {
      value = orders.onHoldOrders;
    } else if (tab === 8) {
      value = orders.deliveredOrders;
    } else if (tab === 9) {
      value = orders.returnInTransitOrders;
    } else if (tab === 10) {
      value = orders.scheduledOrders;
    } else if (tab === 11) { 
      value = orders.days1NotPickedOrders; 
    } else if (tab === 12) { 
      value = orders.days2NotPickedOrders; 
    } else if (tab === 13) { 
      value = orders.days3NotPickedOrders; 
    } else if (tab === 14) { 
      value = orders.days7NotPickedOrders; 
    } else if (tab === 15) { 
      value = orders.days14NotPickedOrders; 
    } else if (tab === 16) { 
      value = orders.days30NotPickedOrders; 
    } else if (tab === 17) { 
      value = orders.days30AboveNotPickedOrders; 
    }
      
    return value;
  };

  const onClickCheckBox = (t,e) => {
    let copyOrders = setOrdersByTab(tab);

    if (t === 'header'){
      let checkSelected = copyOrders.filter(i => i.selected);
      if (checkSelected.length > 0 && checkSelected.length !== copyOrders.length) {
        copyOrders.map(i => {
          i.selected = true;
        })
      } else {
        copyOrders.map(i => {
          i.selected = !i.selected;
        })
      }
    } else {
      let objIndex = copyOrders.findIndex(i => i.orderId === e.orderId);
      copyOrders[objIndex].selected = !copyOrders[objIndex].selected;
    }
    if (tab === 0) {
      setOrders({...orders,tab:0,pendingOrders:copyOrders});
    } else if (tab === 1) {
      setOrders({...orders,tab:1,laterOrders:copyOrders});
    } else if (tab === 2) {
      setOrders({...orders,tab:2,nowOrders:copyOrders});
    } else if (tab === 3) {
      setOrders({...orders,tab:3,processingOrders:copyOrders});
    } else if (tab === 4) {
      setOrders({...orders,tab:4,pickingUpOrders:copyOrders});
    } else if (tab === 5) {
      setOrders({...orders,tab:5,picked:copyOrders});
    } else if (tab === 6) {
      setOrders({...orders,tab:6,otwOrders:copyOrders});
    } else if (tab === 7) {
      setOrders({...orders,tab:7,onHoldOrders:copyOrders});
    } else if (tab === 8) {
      setOrders({...orders,tab:8,deliveredOrders:copyOrders});
    } else if (tab === 9) {
      setOrders({...orders,tab:9,returnInTransitOrders:copyOrders});
    } else if (tab === 10) {
      setOrders({...orders,tab:10,scheduledOrders:copyOrders});
    } else if (tab === 11) {
      setOrders({...orders,tab:11,days1NotPickedOrders:copyOrders});
    } else if (tab === 12) {
      setOrders({...orders,tab:12,days2NotPickedOrders:copyOrders});
    } else if (tab === 13) {
      setOrders({...orders,tab:13,days3NotPickedOrders:copyOrders});
    } else if (tab === 14) {
      setOrders({...orders,tab:14,days7NotPickedOrders:copyOrders});
    } else if (tab === 15) {
      setOrders({...orders,tab:15,days14NotPickedOrders:copyOrders});
    } else if (tab === 16) {
      setOrders({...orders,tab:16,days30NotPickedOrders:copyOrders});
    } else if (tab === 17) {
      setOrders({...orders,tab:17,days30AboveNotPickedOrders:copyOrders});
    }
  };

  const onUpdateDeliveredOrder = () => {
    let tabOrders = setOrdersByTab(tab);
    const availableForConfirm = tabOrders.filter(i =>
        i.courierStatus === 'delivered'
    );

    const totalData = tabOrders.length;
    setDeliveredOrders(availableForConfirm.length)
    let status,message;
    switch (tab) {
      case 1:
          status = 'confirmed';
          break;
      case 2:
          status = 'allocated';
          break;
      case 3:
          status = 'pickingUp';
          break;
      case 4:
          status = 'picked';
          break;
      case 5:
          status = 'droppingOff';
          break;
      case 6:
          status = 'delivered';
          break;
      default:
          break;
    }

    if(window.confirm(`Kami akan segera update ${availableForConfirm.length} order kamu. Kamu yakin?`)) {
        setLoading(true)
        confirmAdminBatchOrder(token, availableForConfirm,status)
            .then(res => {
                if (res.failedOrders > 0 && res.successOrders > 0) {
                    message = `${res.successOrders} Pesanan Berhasil diupdate. ${res.failedOrders} Pesanan gagal diupdate. `
                } else if (res.failedOrders > 0 && res.successOrders === 0) {
                    message = `${res.failedOrders} Pesanan gagal diupdate.`
                } else if (res.failedOrders === 0 && res.successOrders > 0) {
                    message = `${res.successOrders} Pesanan Berhasil diupdate.`
                }
                alert(message);
                window.location.reload()
            });
    }

  };

  const onRefresh = () => {
    _fetchData()
  };

  const onSubmitAdminInfo = () => {
    updateAdminInfo(token, values)
      .then(data => {
        if(data.success) {
          alert("Informasi admin terupdate")
        } else {
          alert("Gagal update admin")
        }
        setShow(false);
        return
      })
  };

  const onOrderRefresh = async () => {
    setRefreshing(true)
    const res = await axios.post(`${API}/v1/admin/orders/refresh`, {}, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: `Bearer ${token}`
      }
    });
    if(res.data.success) {
      alert("Berhasil:" + res.data.updated_orders + ", Gagal:" +res.data.not_updated_orders)
      window.location.reload()
    } else {
      alert(res.data.error);
    }
    setRefreshing(false)
  }

  const handleModalClose = () => setShow(false);
  const handleModalShow = () => setShow(true);
  const handleChange = name => e => {
    const value = e.target.value;
    setValues({ ...values, error:false, success:false, [name]: value });
  };

  const adminInfoModal = () => (
    <Modal show={show} onHide={handleModalClose}>
      <Modal.Header closeButton>
        <h5>Masukan Detail Informasi</h5>
      </Modal.Header>
      <Modal.Body>
        <AdminInfoForm
          handleChange={handleChange}
          values={values}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary btn-sm" onClick={handleModalClose}>
          Tutup
        </Button>
        <Button variant="primary btn-sm" onClick={() => onSubmitAdminInfo()}>
          Simpan
        </Button>
      </Modal.Footer>
    </Modal>
  );

  const infoSection = () => {
    if(values.status !== 'active') {
      return (
          <div className={`alert ${values.status === 'biteship' ? 'alert-info':'alert-warning'}`} role="alert">
          <p className="mb-0"><strong>{values.information}</strong></p>
          <p className="mb-0">{values.details}</p>
        </div>
      );
    }
    return ''
  };

  if (refreshing) {
    return (
        <div className="text-center row">
          <div className="col-3"/>
          <div className="row col-5 py-5">
            <ReactLoading
                type={'bubbles'}
                color={'#459BD8'}
                height={54}
                width={75}
            />
            <h5 className="mt-4 "><strong> Order sedang diupdate. Akan memakan waktu yang lama.</strong></h5>
          </div>
          <div className="col-4"/>
        </div>
    );
  }

  return (
    <div className="bg-white rounded shadow">
      { adminInfoModal() }
      <div className="p-4 d-flex justify-content-between">
        <h5>Semua Pesanan</h5>
        <div className="col-8">
          <div className="row">
            <RefreshButton
              className="col-2 btn btn-sm btn"
              onClick={() => window.location.reload()}
            />
            <div className="col-1"/>
            <button
                className="col-2 btn btn-sm btn btn-info"
                onClick={() => onOrderRefresh()}
            >
              Update Order
            </button>
            <div className="col-1"/>
            <button
                className="col-3 btn btn-sm btn btn-success"
                onClick={() => onUpdateDeliveredOrder()}
            >
              {deliveredOrders} Update Delivered Order 
            </button>
            {/* <button
              className="col-2 btn btn-sm btn btn-info"
              onClick={() => handleModalShow()}
              >
              Informasi
            </button> */}
          </div>
        </div>
      </div>
      { infoSection() }

      <Nav variant="tabs" defaultActiveKey="now">
        <Nav.Item className="ml-4">
          <Nav.Link eventKey="pending" onSelect={() => setTab(0)}>
            Pending
            <span className="badge badge-secondary badge-circle ml-2">
              {orders.pendingOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="later" onSelect={() => setTab(1)}>
            Dikirim Nanti
            <span className="badge badge-secondary badge-circle ml-2">
              {orders.laterOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="later" onSelect={() => setTab(10)}>
            Terjadwal
            <span className="badge badge-secondary badge-circle ml-2">
              {orders.scheduledOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="now" onSelect={() => setTab(2)}>
            Kirim Sekarang
            <span className="badge badge-danger badge-circle ml-2">
              {orders.nowOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="processing" onSelect={() => setTab(3)}>
            Diproses
            <span className="badge badge-info badge-circle ml-2">
              {orders.processingOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="pickingUp" onSelect={() => setTab(4)}>
            Menjemput
            <span className="badge badge-warning badge-circle ml-2">
              {orders.pickingUpOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="picked" onSelect={() => setTab(5)}>
            Dijemput
            <span className="badge badge-warning badge-circle ml-2">
              {orders.picked.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="otw" onSelect={() => setTab(6)}>
            Otw
            <span className="badge badge-warning badge-circle ml-2">
              {orders.otwOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="otw retur" onSelect={() => setTab(9)}>
            Otw Retur
            <span className="badge badge-warning badge-circle ml-2">
              {orders.returnInTransitOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="onHold" onSelect={() => setTab(7)}>
            Ditahan
            <span className="badge badge-danger badge-circle ml-2">
              {orders.onHoldOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="delivered" onSelect={() => setTab(8)}>
            COD
            <span className="badge badge-info badge-circle ml-2">
              {orders.deliveredOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <Nav variant="tabs" defaultActiveKey="now" className='pt-2'>
        <Nav.Item>
          <Nav.Link eventKey="1dayOrder" onSelect={() => setTab(11)}>
            1 hari
            <span className="badge badge-info badge-circle ml-2">
              {orders.days1NotPickedOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link eventKey="2dayOrder" onSelect={() => setTab(12)}>
            2 hari
            <span className="badge badge-info badge-circle ml-2">
              {orders.days2NotPickedOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link eventKey="3dayOrder" onSelect={() => setTab(13)}>
            3 hari
            <span className="badge badge-info badge-circle ml-2">
              {orders.days3NotPickedOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link eventKey="7dayOrder" onSelect={() => setTab(14)}>
            7 hari
            <span className="badge badge-info badge-circle ml-2">
              {orders.days7NotPickedOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link eventKey="14dayOrder" onSelect={() => setTab(15)}>
            14 hari
            <span className="badge badge-info badge-circle ml-2">
              {orders.days14NotPickedOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link eventKey="30dayOrder" onSelect={() => setTab(16)}>
            30 hari
            <span className="badge badge-info badge-circle ml-2">
              {orders.days30NotPickedOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>

        <Nav.Item>
          <Nav.Link eventKey="30AboveDayOrder" onSelect={() => setTab(17)}>
            Diatas 30 hari
            <span className="badge badge-info badge-circle ml-2">
              {orders.days30AboveNotPickedOrders.length}
            </span>
          </Nav.Link>
        </Nav.Item>
      </Nav>
      { adminTab() }
    </div>
  )
};


export default AdminOrder;
